"use client"

import Link from "next/link"
import { LiquidCtaButton } from "@/components/buttons/liquid-cta-button"
import { Sparkles, ArrowLeft, MapPin, Rocket } from "lucide-react"
import { motion } from "framer-motion"

export function HeroSection() {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6 pt-24 pb-20 relative">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-900/50 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto">
        {/* New Branch Announcement - Saudi Arabia */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-gradient-to-r from-green-900/30 to-emerald-900/30 border border-green-700/50 mb-8"
        >
          <div className="flex items-center gap-2">
            <Rocket className="w-4 h-4 text-green-400 animate-pulse" />
            <span className="text-sm text-green-300 font-medium">جديد!</span>
          </div>
          <div className="h-4 w-px bg-green-700/50" />
          <Link href="https://anmka.sa" target="_blank" className="flex items-center gap-2 group">
            <MapPin className="w-4 h-4 text-green-400" />
            <span className="text-sm text-zinc-300 group-hover:text-green-300 transition-colors">
              افتتاح فرع السعودية - جدة
            </span>
            <ArrowLeft className="w-3 h-3 text-green-400 group-hover:-translate-x-1 transition-transform" />
          </Link>
        </motion.div>

        {/* Headline */}
        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6">
          <span className="text-zinc-100 block mb-2">نحول أفكارك</span>
          <span className="bg-gradient-to-r from-zinc-500 via-zinc-300 to-zinc-500 bg-clip-text text-transparent">
            إلى حلول برمجية متكاملة
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto mb-10 leading-relaxed text-balance">
          شركة انمكا للبرمجيات - نقدم منصات تعليمية، متاجر إلكترونية، تطبيقات موبايل، 
          ونظام AI ذكي للمبيعات. خبرة في React, Node.js, Laravel, Flutter
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link href="#contact">
            <LiquidCtaButton>احصل على استشارة مجانية</LiquidCtaButton>
          </Link>
          <Link
            href="/portfolio"
            className="group flex items-center gap-2 px-6 py-3 text-sm font-medium text-zinc-400 hover:text-zinc-100 transition-colors"
          >
            <Sparkles className="w-4 h-4" />
            <span>أهم أعمالنا</span>
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-300" />
          </Link>
        </div>

        {/* Tech Stack & Trust */}
        <div className="mt-16 flex flex-col items-center gap-6">
          {/* Tech Stack */}
          <div className="flex flex-wrap items-center justify-center gap-3">
            {["React", "Node.js", "Laravel", "Flutter", "Next.js", "AI"].map((tech) => (
              <span
                key={tech}
                className="px-4 py-2 text-sm text-zinc-400 bg-zinc-900/50 border border-zinc-800 rounded-full hover:border-zinc-700 hover:text-zinc-300 transition-all"
              >
                {tech}
              </span>
            ))}
          </div>

          {/* Branches */}
          <div className="flex items-center gap-6 text-sm text-zinc-500">
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              <span>مصر الجديدة - القاهرة</span>
            </div>
            <div className="h-4 w-px bg-zinc-800" />
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-green-500" />
              <span className="text-green-400">جدة - السعودية</span>
              <span className="text-xs bg-green-900/30 text-green-400 px-2 py-0.5 rounded-full">جديد</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
